<div class="container-fluid">
    <app-pagetitle title="Estamp Customers" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>


    <div class="page-content-wrapper">

        <app-loader [loading]="loading"></app-loader>

        <div [class.loading-content]="loading">

            <div class="row">
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-body">
                            <app-filter (filterChange)="filterChange($event)" [statusOptions]="statusOptions"
                                searchBY="Name, Email, Company & Phone "></app-filter>

                            <p-table #dt [value]="customers" [lazy]="true" (onLazyLoad)="loadCustomers($event)"
                                [paginator]="true" [rows]="rows" [totalRecords]="totalRecords"
                                [rowsPerPageOptions]="[10,20,50]" responsiveLayout="scroll"
                                styleClass="p-datatable-sm fs-6 customer-table" [showCurrentPageReport]="true"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">

                                <ng-template pTemplate="header">
                                    <tr>
                                        <th class="name-column">Name</th>
                                        <th class="email-column">Email</th>
                                        <th class="status-column text-center">Status</th>
                                        <th class="company-column">Company</th>
                                        <th class="phone-column">Phone</th>
                                        <th class="service-charge-column text-center">Service Charge (%)</th>
                                        <th class="created-column">Created</th>
                                        <th class="action-column text-center">Action</th>
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="body" let-customer>
                                    <tr>
                                        <td class="name-column">{{ customer.name }}</td>
                                        <td class="email-column">{{ customer.email }}</td>
                                        <td class="status-column text-center">
                                            <div class="badge font-size-12" [ngClass]="{
                            'bg-success-subtle text-success': customer.estampService === 'ACTIVE',
                            'bg-warning-subtle text-warning': customer.estampService === 'REQUESTED',
                            'bg-danger-subtle text-danger': customer.estampService === 'INACTIVE'
                        }">
                                                {{ customer.estampService }}
                                            </div>
                                        </td>

                                        <td class="company-column">{{ customer.company }}</td>
                                        <td class="phone-column">{{ customer.phone }}</td>
                                        <td class="service-charge-column text-center">
                                            {{ customer.bulkServiceChargeRate !== null &&
                                            customer.bulkServiceChargeRate !== undefined
                                            ? (customer.bulkServiceChargeRate | percent:'1.0-2') : '-' }}
                                        </td>
                                        <td class="created-column">{{ customer.createdAt | date:'short' }}</td>

                                        <!-- <td class="d-flex align-items-center gap-2">
                                    <a href="javascript:void(0);" class="text-primary" (click)="viewInfo(customer)"
                                        ngbTooltip="Detail">
                                        <i class="mdi mdi-information font-size-18"></i>
                                    </a>

                                </td> -->

                                        <td class="action-column text-center position-relative">
                                            <div class="action-wrapper">

                                                <!-- Three dots -->
                                                <button class="btn btn-sm btn-light" (click)="toggleMenu(customer._id)">
                                                    ⋮
                                                </button>

                                                <!-- Dropdown -->
                                                <div class="custom-dropdown" *ngIf="activeMenuId === customer._id">

                                                    <button class="dropdown-item"
                                                        (click)="assignedMaker(customer, planModal)">
                                                        <i class="mdi mdi-eye fs-4 me-2" style="cursor:pointer;"
                                                            title="View"></i>
                                                        View
                                                    </button>
                                                    <button class="dropdown-item"
                                                        (click)="confingModal(customer, configModal)">
                                                        <i class="mdi mdi-cog fs-4 me-2" style="cursor:pointer;"
                                                            title="Config"></i>
                                                        Config
                                                    </button>


                                                </div>

                                            </div>
                                        </td>
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="8" class="text-center py-4 text-muted">
                                            <i class="mdi mdi-database-off-outline me-2"></i>
                                            No customers found
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <ng-template #planModal let-modal>
            <div class="modal-header">
                <h5 class="modal-title">Customer Detail</h5>
                <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
            </div>
            <div class="modal-body">

                <!-- Customer detail -->
                <div class="row mb-3">
                    <div class="col-md-6 mb-2">
                        <div class="fw-semibold">Name</div>
                        <div>{{ selectedCustomer?.name || '-' }}</div>
                    </div>
                    <div class="col-md-6 mb-2">
                        <div class="fw-semibold">Status</div>
                        <div class="badge font-size-12" [ngClass]="{
                            'bg-success-subtle text-success': selectedCustomer.estampService === 'ACTIVE',
                            'bg-warning-subtle text-warning': selectedCustomer.estampService === 'REQUESTED',
                            'bg-danger-subtle text-danger': selectedCustomer.estampService === 'INACTIVE'
                        }">
                            {{ selectedCustomer.estampService }}
                        </div>
                    </div>
                    <div class="col-md-12 mb-2">
                        <div class="fw-semibold">Email</div>
                        <div>{{ selectedCustomer?.email || '-' }}</div>
                    </div>
                    <div class="col-md-6 mb-2">
                        <div class="fw-semibold">Company</div>
                        <div>{{ selectedCustomer?.company || '-' }}</div>
                    </div>
                    <div class="col-md-6 mb-2">
                        <div class="fw-semibold">Phone</div>
                        <div>{{ selectedCustomer?.phone || '-' }}</div>
                    </div>
                </div>

                <!-- Maker dropdown -->
                @if(selectedCustomer?.estampService === 'REQUESTED' ){
                <div class="mb-2">
                    <label class="form-label fw-semibold mb-1">Assign Maker</label>
                    <select class="form-select" [(ngModel)]="selectedMakerId">
                        <option value="" disabled>Select a maker</option>
                        @for(maker of makers; track maker._id){
                        <option [value]="maker._id">
                            {{ maker.name }} ({{ maker.email }})
                        </option>
                        }
                    </select>
                    @if(!makers.length){
                    <small class="text-muted">No makers available</small>
                    }
                </div>
                <!-- <div class="mb-2">
                    <label class="form-label fw-semibold mb-1">Commission (%)</label>
                    <input type="number" class="form-control" min="0" max="100" step="0.01"
                        placeholder="Enter Service Charge" [(ngModel)]="commission">
                </div> -->
                }@else{
                <div class="col-md-6 mb-2">
                    <div class="fw-semibold">Assigned Maker</div>
                    <div>{{ selectedCustomer?.userName || '-' }}</div>
                </div>
                }

            </div>
            @if(selectedCustomer?.estampService === 'REQUESTED' ){
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="closeModal()">Cancel</button>
                <button type="button" class="btn btn-primary" (click)="submitAssignMaker()" [disabled]="assigning">
                    {{ assigning ? 'Loading...' : 'Submit' }}
                </button>
            </div>
            }
        </ng-template>

        <ng-template #configModal let-modal>
            <div class="modal-header">
                <h5 class="modal-title">Client Loss Policy Config</h5>
                <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
            </div>
            <div class="modal-body">

                @if(loadingConfig){
                <div class="text-center py-4">
                    <span class="spinner-border spinner-border-sm me-2"></span> Loading...
                </div>
                }@else{

                <div class="mb-2">
                    <label class="form-label fw-semibold mb-1">Client Email</label>
                    <div>{{ configCustomer?.email || '-' }}</div>
                </div>

                <div class="row">
                    <div class="mb-2 col-6">
                        <label class="form-label fw-semibold mb-1">First Party Name</label>
                        <input type="text" class="form-control" placeholder="Enter first party name"
                            [(ngModel)]="firstParty">
                    </div>

                    <div class="mb-2 col-6">
                        <label class="form-label fw-semibold mb-1"> Service Charge Rate (%)</label>
                        <input type="text" class="form-control" placeholder="Enter Service Charge Rate"
                            [(ngModel)]="serviceChargeRate">
                    </div>

                </div>

                <div class="mb-2">
                    <label class="form-label fw-semibold mb-1">Email Recipients</label>
                    <textarea class="form-control" rows="2" placeholder="Enter comma-separated email addresses"
                        [(ngModel)]="emailRecipients" (ngModelChange)="emailRecipientsInvalid = false"
                        [class.is-invalid]="emailRecipientsTouched && emailRecipientsInvalid"></textarea>
                    <div class="invalid-feedback" *ngIf="emailRecipientsTouched && emailRecipientsInvalid">
                        Enter valid comma-separated email addresses.
                    </div>
                    <small class="text-muted">Separate multiple email addresses with commas.</small>
                </div>

                <div class="mb-2">
                    <label class="form-label fw-semibold mb-1">Loss Policy Mode</label>
                    <select class="form-select" [(ngModel)]="lossPolicyMode">
                        <option value="NONE">None</option>
                        <option value="BLOCK">Block</option>
                        <option value="MAX_AMOUNT">Max Amount</option>
                        <option value="MAX_PERCENTAGE">Max Percentage</option>
                    </select>
                </div>

                @if(lossPolicyMode === 'MAX_AMOUNT'){
                <div class="mb-2">
                    <label class="form-label fw-semibold mb-1">Max Loss Amount (₹)</label>
                    <input type="number" class="form-control" min="0" step="0.01" placeholder="Enter max loss amount"
                        [(ngModel)]="maxLossAmount">
                </div>
                }
                @if(lossPolicyMode === 'MAX_PERCENTAGE'){
                <div class="mb-2">
                    <label class="form-label fw-semibold mb-1">Max Loss Percentage (%)</label>
                    <input type="number" class="form-control" min="0" max="100" step="0.01"
                        placeholder="Enter max loss percentage" [(ngModel)]="maxLossPercentage">
                </div>
                }

                <div class="mb-2">
                    <label class="form-label fw-semibold mb-1">Reason</label>
                    <textarea class="form-control" rows="2" placeholder="Enter reason"
                        [(ngModel)]="configReason"></textarea>
                </div>

                }

            </div>
            @if(!loadingConfig){
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="closeModal()">Cancel</button>
                <button type="button" class="btn btn-primary" (click)="submitConfig()" [disabled]="savingConfig">
                    {{ savingConfig ? 'Loading...' : 'Submit' }}
                </button>
            </div>
            }
        </ng-template>
    </div>
</div>